// Central Dhivehi (Thaana) UI strings. Single source of truth — no inline literals in pages.
// Thaana terms matched to wapmeet/wapstat ecosystem where available.
export const t = {
  app: {
    name: 'ވެޕްޕްރޯ',
    subtitle: 'ކައުންސިލް ޕްރޮކިއުމަންޓް',
  },
  common: {
    cancel: 'ކެންސަލް',
    confirm: 'ޔަގީންކުރޭ',
    page: 'ޞަފްޙާ', next: 'ކުރިއަށް', prev: 'ފަހަތަށް',
  },
  roles: {
    SYS_ADMIN: 'ސިސްޓަމް އެޑްމިން',
    ADMIN: 'އެޑްމިން',
    STAFF: 'ޕްރޮކިއުމަންޓް ސްޓާފް',
    STOCKKEEPER: 'ސްޓޮކްކީޕަރ',
    FINANCE: 'ފައިނޭންސް',
  },
  time: {
    days: 'ދުވަސް',
    hours: 'ގަޑި',
    minutes: 'މިނެޓް',
    seconds: 'ސިކުންތު',
    remaining: 'ބާކީ',
    passed: 'ސުންގަޑި ހަމަވެއްޖެ',
  },
  nav: {
    dashboard: 'ޑޭޝްބޯޑް',
    requests: 'ރިކުއެސްޓްތައް',
    gsrs: 'ރިކުއިޒިޝަންތައް',
    vendors: 'ވިއްކާ ފަރާތްތައް',
    finance: 'ފައިސާ',
    logout: 'ލޮގްއައުޓް',
    mainNav: 'މެއިން ނެވިގޭޝަން',
    skipToMain: 'މައި ކޮންޓެންޓަށް ދޭ',
    signOut: 'ލޮގްއައުޓް',
  },
  theme: {
    switchToLight: 'ލައިޓް ތީމަށް ބަދަލުކުރޭ',
    switchToDark: 'ޑާރކް ތީމަށް ބަދަލުކުރޭ',
  },
  dashboard: {
    // dv.ts reused: dashboard='ޑޭޝްބޯޑް', welcome='މަރުޙަބާ'
    heading: 'ޑޭޝްބޯޑް',
    welcome: 'މަރުޙަބާ،',
    comingSoon: 'އިތުރު ފީޗާތައް ހިމަނަނީ.',
    loading: 'ލޯޑްވަނީ…',
    // Stat cards
    gsrsOpen: 'ކުރިއަށްދާ GSR',
    activeRfqs: 'ހުޅުވިފައިވާ ކޯޓޭޝަން',
    readyToAward: 'ފަރާތް ކަނޑައަޅަން ތައްޔާރު',
    awaitingPayment: 'ފައިސާ ދައްކަން ހުރި',
    activeVendors: 'ވިއްކާ ފަރާތްތައް',
    // Recent + attention
    recentHeading: 'އެންމެ ފަހުގެ ރިކުއެސްޓްތައް',
    noRequests: 'އަދި ރިކުއެސްޓެއް ނެތް.',
    attentionHeading: 'ސަމާލުކަން ބޭނުންވާ',
    readyToAwardNote: (n: number) => `${n} ރިކުއެސްޓަށް ފަރާތް ކަނޑައެޅޭ ވަރަށް އަގު ލިބިއްޖެ`,
    awaitingPaymentNote: (n: number) => `${n} ބިލަށް ފައިސާ ދައްކަން ޖެހޭ`,
    statusDraft: 'ޑްރާފްޓް',
    statusSent: 'ފޮނުވާފައި',
    statusClosed: 'ބަންދު',
  },
  login: {
    // dv.ts reused: email='އީމެއިލް', password='ޕާސްވޯޑް', login='ވަންނަން', logout='ލޮގްއައުޓް', signingIn='ވަންނަނީ…'
    title: 'ވަންނަން',
    subtitle: 'ކްރެޑެންޝަލްތައް ލިޔެ ކުރިޔަށް ދޭ.',
    heroTagline: 'ޕްރޮކިއުމަންޓް\nލުއިފަސޭހަ.',
    heroDescription: 'ސްޓާފުން ތަކެތީ ރިކުއެސްޓް ހަދައި. ވިއްކާ ފަރާތްތައް އަގު ހުށަހަޅައި. ތިބާ ހިޔާލުކޮށް ދޭ.',
    email: 'އީމެއިލް',
    password: 'ޕާސްވޯޑް',
    showPassword: 'ޕާސްވޯޑް ދައްކާ',
    hidePassword: 'ޕާސްވޯޑް ފޮރުވާ',
    submit: 'ވަންނަން',
    submitting: 'ވަންނަނީ…',
    errorInvalid: 'އީމެއިލް ނުވަތަ ޕާސްވޯޑް ރަނގަޅެއް ނޫން.',
    errorTooMany: 'ލޮގިން ކުރެވޭ ވަރު ފަހަނަ އަޅާ ދިޔައީ. ކުޑަ ވަގުތެއް ފަހުން ތިޔަ ކުރޭ.',
    errorGeneral: 'ކޮންމެވެސް ގޯހެއް ވެއްޖެ. ދެން ތިޔަ ކުރޭ.',
  },
  requests: {
    // dv.ts reused: cancel='ކެންސަލް', loading='ލޯޑްވަނީ…'
    title: 'ތަކެތި ރިކުއެސްޓްތައް',
    newRequest: 'އައު ރިކުއެސްޓް',
    filterAll: 'ހުރިހާ',
    searchPlaceholder: 'ރިކުއެސްޓް ހޯދާ…',
    // Status display labels (enum values DRAFT/SENT/CLOSED kept as code)
    statusDraft: 'ޑްރާފްޓް',
    statusSent: 'ފޮނުވާފައި',
    statusClosed: 'ބަންދު',
    colRef: 'ރެފް',
    colTitle: 'ސުރުޚީ',
    colStatus: 'ހާލަތު',
    colItems: 'ތަކެތި',
    colDeadline: 'ސުންގަޑި',
    colView: 'ބަލާ',
    loading: 'ލޯޑްވަނީ…',
    empty: 'އަދި ރިކުއެސްޓެއް ނެތް. މަތިން ހަދައިލާ.',
  },
  requestNew: {
    // dv.ts reused: cancel='ކެންސަލް', submit='ހުށަހަޅާ'
    title: 'އައު ތަކެތި ރިކުއެސްޓް',
    subtitle: 'ބޭނުންވާ ތަކެތި ލިޔެ ހުށަހަޅާ — ވިއްކާ ފަރާތްތަކުން ކޮންމެ ތަކެއްޗެއްގެ އަގު ދޭ.',
    requestTitle: 'ރިކުއެސްޓްގެ ސުރުޚީ',
    requestTitlePlaceholder: 'މިސާލު: ސިންދެ ތަކެތި Q3 2026',
    itemsSectionTitle: 'ތަކެތި',
    colItem: 'ތަކެތި',
    colQty: 'އަދަދު',
    colUnit: 'ހަމަ',
    colSpec: 'ތަފްސީލު',
    placeholderItem: 'ތަކެތީގެ ނަން',
    placeholderQty: 'އަދަދު',
    placeholderUnit: 'ޕީސް، ކިލޯ…',
    placeholderSpec: 'ބްރޭންޑް، ސައިޒު… (އިޚްތިޔާރީ)',
    ariaItem: 'ތަކެތީގެ ނަން',
    ariaQty: 'އަދަދު',
    ariaUnit: 'ހަމަ',
    ariaSpec: 'ތަފްސީލު',
    ariaRemove: 'ތަކެތި ނަގާ',
    addItem: 'ތަކެތި އިތުރުކުރޭ',
    submit: 'ހުށަހަޅާ',
    submitting: 'ހުށަހަޅަނީ…',
    cancel: 'ކެންސަލް',
    errorNoItems: 'ނަމާއި، ހަމައާއި، އަދަދު ހިމެނޭ ތަކެތި ވަދެ ފުރިހަމަ ކުރޭ.',
    errorFailed: 'ރިކުއެސްޓް ހެދޭ ގޮތް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
  },
  vendors: {
    // dv.ts reused: loading='ލޯޑްވަނީ…', search='ހޯދާ', cancel='ކެންސަލް', save='ސޭވްކުރޭ'
    title: 'ވިއްކާ ފަރާތްތައް',
    addVendor: 'ވިއްކާ ފަރާތް އިތުރުކުރޭ',
    filterAll: 'ހުރިހާ',
    tabVendors: 'ވިއްކާ ފަރާތްތައް',
    tabTypes: 'ވިއްކާ ފަރާތްތަކުގެ ބާވަތްތައް',
    newVendorHeading: 'އައު ވިއްކާ ފަރާތް',
    // Form fields
    fieldName: 'ނަން',
    fieldPhone: 'ފޯނު',
    fieldIdCard: 'އައިޑީ ކާޑު ނަންބަރު',
    fieldIdCardFormat: '(ފޯމެޓް: A123456)',
    fieldIdCardPlaceholder: 'A123456',
    fieldAddress: 'އެޑްރެސް',
    fieldBankAccountNumber: 'ބޭންކް އެކައުންޓް ނަންބަރު',
    fieldBankAccountName: 'ބޭންކް އެކައުންޓްގެ ނަން',
    fieldEmail: 'އީމެއިލް',
    fieldEmailHint: 'ކޯޓޭޝަން ދައުވަތު ފޮނުވޭ ގޮތް ވޭ.',
    fieldVendorTypes: 'ވިއްކާ ފަރާތްތަކުގެ ބާވަތް',
    fieldRequired: '*',
    // Saving states
    saving: 'ސޭވްކުރަނީ…',
    saveVendor: 'ވިއްކާ ފަރާތް ސޭވްކުރޭ',
    cancel: 'ކެންސަލް',
    // Status
    statusActive: 'އެކްޓިވް',
    statusInactive: 'ޑީއެކްޓިވޭޓްކޮށްފައި',
    // Search
    searchPlaceholder: 'ވިއްކާ ފަރާތްތައް ހޯދާ…',
    searchAriaLabel: 'ވިއްކާ ފަރާތްތައް ހޯދާ',
    // Loading / empty states
    loading: 'ލޯޑްވަނީ…',
    emptySearch: 'ހޯދި ވިއްކާ ފަރާތެއް ނެތް.',
    emptyList: 'ވިއްކާ ފަރާތެއް ނެތް. މަތިން އިތުރުކުރޭ.',
    // Table headers
    colName: 'ނަން',
    colIdCard: 'އައިޑީ ކާޑު',
    colPhone: 'ފޯނު',
    colStatus: 'ހާލަތު',
    // Edit link
    edit: 'އެޑިޓް',
    // Errors
    errorIdCard: 'އައިޑީ ކާޑު ނަންބަރު ރަނގަޅެއް ނޫން (ފޯމެޓް: A123456)',
    errorSave: 'ވިއްކާ ފަރާތް ސޭވްނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    // Login credentials
    colLogin: 'ލޮގިން',
    sendCredentials: 'ލޮގިން ކްރެޑެންޝަލް ފޮނުވާ',
    sendingCredentials: 'ފޮނުވަނީ…',
    credentialsSent: (date: string) => `ކްރެޑެންޝަލް ފޮނުވި: ${date}`,
    credentialsNotSent: 'ކްރެޑެންޝަލް ފޮނުވާފައި ނެތް',
    credentialsNoEmail: 'އީމެއިލް ނެތް — ފޮނުވޭ ގޮތެއް ނެތް',
    credentialsSentOk: 'ލޮގިން ކްރެޑެންޝަލް ފޮނުވައިފި.',
    credentialsError: 'ފޮނުވޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
  },
  vendorEdit: {
    // dv.ts reused: loading='ލޯޑްވަނީ…', back='އަނބުރާ', cancel='ކެންސަލް', save='ސޭވްކުރޭ'
    loading: 'ލޯޑްވަނީ…',
    notFound: 'ވިއްކާ ފަރާތެއް ނެތް.',
    ariaBack: 'ވިއްކާ ފަރާތްތަކަށް ދޭ',
    editHeading: 'ވިއްކާ ފަރާތް އެޑިޓްކުރޭ',
    // Form fields (same keys as vendors, shared labels)
    fieldName: 'ނަން',
    fieldPhone: 'ފޯނު',
    fieldIdCard: 'އައިޑީ ކާޑު ނަންބަރު',
    fieldIdCardFormat: '(ފޯމެޓް: A123456)',
    fieldIdCardPlaceholder: 'A123456',
    fieldAddress: 'އެޑްރެސް',
    fieldBankAccountNumber: 'ބޭންކް އެކައުންޓް ނަންބަރު',
    fieldBankAccountName: 'ބޭންކް އެކައުންޓްގެ ނަން',
    fieldEmail: 'އީމެއިލް',
    fieldEmailHint: 'ކޯޓޭޝަން ދައުވަތު ފޮނުވޭ ގޮތް ވޭ.',
    fieldVendorTypes: 'ވިއްކާ ފަރާތްތަކުގެ ބާވަތް',
    fieldRequired: '*',
    // Status
    statusActive: 'އެކްޓިވް',
    statusInactive: 'ޑީއެކްޓިވޭޓްކޮށްފައި',
    // Actions
    saving: 'ސޭވްކުރަނީ…',
    saveChanges: 'ބަދަލު ސޭވްކުރޭ',
    autosaveSaved: 'ސޭވްކުރެވިއްޖެ',
    cancel: 'ކެންސަލް',
    deactivate: 'ޑީއެކްޓިވޭޓްކުރޭ',
    deactivating: 'ޑީއެކްޓިވޭޓްކުރަނީ…',
    deactivateConfirm: 'މި ވިއްކާ ފަރާތް ޑީއެކްޓިވޭޓްކުރަންވީތަ؟ ދެން ދައުވަތު ނުފޮނުވޭ.',
    deactivateSuccess: 'ވިއްކާ ފަރާތް ޑީއެކްޓިވޭޓްކޮށްފި.',
    activate: 'އެކްޓިވޭޓްކުރޭ',
    activating: 'އެކްޓިވޭޓްކުރަނީ…',
    activateSuccess: 'ވިއްކާ ފަރާތް އެކްޓިވޭޓްކޮށްފި.',
    // Errors
    errorIdCard: 'އައިޑީ ކާޑު ނަންބަރު ރަނގަޅެއް ނޫން (ފޯމެޓް: A123456)',
    errorUpdate: 'ވިއްކާ ފަރާތް ބަދަލެއް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    errorDeactivate: 'ވިއްކާ ފަރާތް ޑީއެކްޓިވޭޓެއް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    errorActivate: 'ވިއްކާ ފަރާތް އެކްޓިވޭޓެއް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    // Login credentials
    loginHeading: 'ވިއްކާ ފަރާތުގެ ލޮގިން',
    sendCredentials: 'ލޮގިން ކްރެޑެންޝަލް ފޮނުވާ',
    resendCredentials: 'ކްރެޑެންޝަލް އަލުން ފޮނުވާ',
    sendingCredentials: 'ފޮނުވަނީ…',
    credentialsSent: (date: string) => `ކްރެޑެންޝަލް ފޮނުވި: ${date}`,
    credentialsNotSent: 'ކްރެޑެންޝަލް ފޮނުވާފައި ނެތް.',
    credentialsNoEmail: 'އީމެއިލް ނެތުމުން ލޮގިން ކްރެޑެންޝަލް ފޮނުވޭ ގޮތެއް ނެތް.',
    credentialsSentOk: 'ލޮގިން ކްރެޑެންޝަލް ފޮނުވައިފި.',
    credentialsError: 'ފޮނުވޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    // Per-vendor letterhead (mirrors orgSettings header/footer/text)
    letterheadHeading: 'ލެޓަރހެޑް',
    letterheadHint: 'ފުރިހަމަ ނުކުރައްޔާ، ޖަމިއްޔާގެ ޑިފޯލްޓް ލެޓަރހެޑް ބޭނުންކުރެވޭނެ.',
    letterheadHeaderImageLabel: 'ބޭލިމަތި',
    letterheadFooterImageLabel: 'ތިރި',
    letterheadFooterTextLabel: 'ފޫޓަރ ލިޔުން',
    letterheadFooterTextPlaceholder: 'ލިޔުން',
    currentImage: 'ހިމެނިފައި',
    noImage: 'ފޮޓޯ ލެވިފައި ނެތް (ޖަމިއްޔާގެ ޑިފޯލްޓް ބޭނުންކުރެވޭނެ)',
    uploadBtn: 'ފޮޓޯ ބަދަލުކުރޭ',
    removeImage: 'ފޮޓޯ ނަގާ',
    removing: 'ނަގަނީ…',
    uploadHint: 'PNG ، JPEG ، ގިނަވެ 2 MB',
    saveFooterText: 'ލިޔުން ސޭވްކުރޭ',
    letterheadSaving: 'ސޭވްކުރަނީ…',
    letterheadSavedOk: 'ސޭވްކޮށްފި.',
    letterheadErrorSave: 'ސޭވްނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    letterheadErrorFileSize: 'ފޮޓޯ 2 MB ތަށް ބޮޑެއް.',
    letterheadErrorFileType: 'PNG ، JPEG ގެ ފޮޓޯ ހިޔާރުކުރޭ.',
    ariaUploadHeader: 'ލެޓަރހެޑް ބޭލިމަތި ފޮޓޯ ހިޔާރުކުރޭ',
    ariaUploadFooter: 'ލެޓަރހެޑް ތިރި ފޮޓޯ ހިޔާރުކުރޭ',
  },
  manageTypes: {
    heading: 'ވިއްކާ ފަރާތްތަކުގެ ބާވަތްތައް',
    empty: 'ބާވަތެއް ނެތް.',
    addPlaceholder: 'އައު ބާވަތެއްގެ ނަން…',
    addType: 'ބާވަތް އިތުރުކުރޭ',
    adding: 'އިތުރުކުރަނީ…',
    ariaRename: 'ބަދަލުކުރޭ',
    ariaDelete: 'ޑިލީޓްކުރޭ',
    ariaSaveRename: 'ބަދަލު ސޭވްކުރޭ',
    ariaCancelRename: 'ބަދަލު ކެންސަލް',
    deleteConfirm: 'މި ވިއްކާ ފަރާތްތަކުގެ ބާވަތް ޑިލީޓްކުރަންވީތަ؟',
    errorTypeExists: 'މި ނަމުގެ ބާވަތެއް މިހާރުވެސް އެބައޮތް.',
    errorAdd: 'ބާވަތް އިތުރެއް ނުކުރެވުުނ. ދެން ތިޔަ ކުރޭ.',
    errorTypeExistsRename: 'މި ނަމުގެ ބާވަތެއް މިހާރުވެސް އެބައޮތް.',
    errorRename: 'ބާވަތް ބަދަލެއް ނުކުރެވުުނ. ދެން ތިޔަ ކުރޭ.',
  },
  requestDetail: {
    // dv.ts reused: loading='ލޯޑްވަނީ…', back='އަނބުރާ', cancel='ކެންސަލް', confirm='ޔަގީންކުރޭ', download='ޑައުންލޯޑް'
    loading: 'ލޯޑްވަނީ…',
    notFound: 'ރިކުއެސްޓެއް ނެތް.',
    ariaBack: 'ރިކުއެސްޓްތަކަށް ދޭ',
    createdAt: 'ތައްޔާރުކުރި',
    // Items section
    itemsHeading: 'ތަކެތި',
    colNum: '#',
    colItem: 'ތަކެތި',
    colQty: 'އަދަދު',
    colUnit: 'ހަމަ',
    colSpec: 'ތަފްސީލު',
    // Status display labels (enum values DRAFT/SENT/CLOSED kept as code)
    statusDraft: 'ޑްރާފްޓް',
    statusSent: 'ފޮނުވާފައި',
    statusClosed: 'ބަންދު',
    // Invites panel
    vendorInvitations: 'ވިއްކާ ފަރާތްތަކަށް ދައުވަތު',
    selectVendorTypes: 'ދައުވަތު ދޭ ވިއްކާ ފަރާތްތަކުގެ ބާވަތް ހޮވާ',
    noVendorTypes: 'ވިއްކާ ފަރާތްތަކުގެ ބާވަތް ކަނޑައަޅާފައި ނެތް. ވިއްކާ ފަރާތްތަކުގެ ޞަފްޙާއިން ބާވަތްތައް ކަނޑައަޅާ.',
    sendForQuotes: 'ކޯޓޭޝަންއަށް ދައުވަތު ފޮނުވާ',
    sending: 'ފޮނުވަނީ…',
    sendFailed: 'ފޮނުވޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    sentTo: 'ދައުވަތު ދިން',
    vendor: 'ވިއްކާ ފަރާތް',
    vendors: 'ވިއްކާ ފަރާތްތައް',
    alreadyInvited: 'ކުރިން ދައުވަތު ދީފައި',
    skippedNoEmail: 'ދޫކޮށްލި (އީމެއިލް ނެތް):',
    failedDeliver: 'ނުފޮނުވުނު:',
    inviteLoading: 'ދައުވަތުތައް ލޯޑްވަނީ…',
    noInvites: 'އަދި ދައުވަތެއް ނުދޭ.',
    statusSubmitted: 'ހުށަހަޅައިފި',
    statusPending: 'ނިންމަން ހުރި',
    sendFail: 'ފޮނުވޭ ގޮތެއް ނުވިއެ',
    resend: 'އަލުން ފޮނުވާ',
    resending: 'ފޮނުވަނީ…',
    resendFailed: 'ފޮނުވޭ ގޮތެއް ނުވިއެ.',
    // Comparison table
    quoteComparison: 'އަގުބެލުމުގެ ތާވަލު',
    response: 'ޖަވާބު',
    responses: 'ޖަވާބުތައް',
    noResponses: 'ވިއްކާ ފަރާތްތަކުގެ ޖަވާބެއް ނެތް.',
    // Decision strip + matrix
    bidsLabel: 'ހުށަހެޅި',
    lowestTotalLabel: 'އެންމެ ދަށް ޖުމްލަ',
    savingsLabel: 'ސަލާމަތްވި',
    totalRow: 'ޖުމްލަ',
    awardedTo: 'ކޯންޓްރެކްޓް ދިނީ',
    documentsLabel: 'ލިޔެކިޔުންތައް',
    submittedAtLabel: 'ފޮނުވި',
    loadingComparison: 'ތަފާތު ލޯޑްވަނީ…',
    comparisonError: 'ތަފާތު ތަފްސީލު ލޯޑެއް ނުކުރެވުނު.',
    colItemName: 'ތަކެތި',
    colQtyShort: 'އަދަދު',
    incomplete: 'ފުރިހަމަ ނޫން',
    winner: 'ދިން',
    total: 'ޖުމްލަ',
    partial: '(ތަފާތު)',
    // Ranked comparison list (lowest price first)
    bestPrice: 'އެންމެ ހެޔޮ އަގު',
    rank: 'ދަރަޖަ',
    showBreakdown: 'ތަކެތީގެ އަގުތައް ދައްކާ',
    hideBreakdown: 'ތަކެތީގެ އަގުތައް ފޮރުވާ',
    // Award
    awardTo: 'ދިނީ',
    awarding: 'ދެނީ…',
    awardConfirmBtn: 'ޔަގީންކުރޭ',
    awardFailed: 'ކޯންޓްރެކްޓް ދެވޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    awardBtn: 'ކޯންޓްރެކްޓް ދޭ',
    awardDisabledTitle: 'ވިއްކާ ފަރާތުގެ ޖަވާބު ފުރިހަމަ ނޫން',
    awardEnabledTitle: 'މި ވިއްކާ ފަރާތަށް ކޯންޓްރެކްޓް ދޭ',
    // Document downloads
    quotation: 'ކޯޓޭޝަން',
    invoice: 'އިންވޮއިސް',
    opening: 'ހުޅުވަނީ…',
    dlQuotationTitle: 'ކޯޓޭޝަން PDF ޑައުންލޯޑްކުރޭ',
    dlInvoiceTitle: 'އިންވޮއިސް PDF ޑައުންލޯޑްކުރޭ',
    // aria-labels
    ariaVendorInvitations: 'ވިއްކާ ފަރާތްތަކަށް ދައުވަތު',
    ariaQuoteComparison: 'ކޯޓޭޝަން ތަފާތު',
    // Submission window / deadline
    deadlineLabel: 'ސުންގަޑި',
    noDeadline: 'ސުންގަޑިއެއް ކަނޑައަޅާފައި ނެތް',
    windowHoursLabel: 'ހުށަހެޅުމުގެ ވަގުތު (ގަޑިއިރު)',
    windowHoursHint: '1–24 ގަޑިއިރު',
    extendWindow: 'ސުންގަޑި އިތުރުކުރޭ',
    extending: 'އިތުރުކުރަނީ…',
    extendFailed: 'ސުންގަޑި އިތުރެއް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    extendEnoughQuotes: '3 ނުވަތަ އެއަށްވުރެ ގިނަ ކޯޓޭޝަން ލިބިފައިވާތީ ސުންގަޑި އިތުރެއް ނުކުރެވޭ.',
    extendOk: 'ސުންގަޑި ބަދަލުކޮށްފި.',
    // Award payment
    awardedAmount: 'ދިން އަގު',
    paid: 'ފައިސާ ދައްކައިފި',
    unpaid: 'ފައިސާ ނުދައްކާ',
    markPaid: 'ފައިސާ ދައްކައިފިކަމަށް ފާހަގަކުރޭ',
    markUnpaid: 'ފައިސާ ނުދައްކާކަމަށް ފާހަގަކުރޭ',
    paymentUpdateFailed: 'ފައިސާގެ ހާލަތު ބަދަލެއް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    // Send-to-finance handoff
    paidBadge: 'ފައިސާ ދައްކާފައި',
    sentToFinanceBadge: 'ފައިސާއަށް ފޮނުވިފައި',
    sendingToFinance: 'ފޮނުވަނީ…',
    // Purchase Order (PO) uploads + merged package preview
    poSectionLabel: 'ޕަރޗޭސް އޯޑަރު',
    poAddBtn: 'ފައިލް އިތުރުކުރައްވާ',
    poUploading: 'އަޕްލޯޑްވަނީ…',
    poRemove: 'ނަގާ',
    poRequiredHint: 'ފައިސާއަށް ފޮނުވުމަށްޓަކައި މަދުވެގެން 1 ޕަރޗޭސް އޯޑަރު އަޕްލޯޑްކުރައްވަންޖެހޭ.',
    poInvalidFile: 'ފައިލެއް ބަލައިނުގަނެވުނު. PDF ނުވަތަ ފޮޓޯ (PNG/JPG) ބޭނުންކުރައްވާ.',
    poDeleteFailed: 'ފައިލް ނުނެގުނު. ދެން ތިޔަ ކުރޭ.',
    previewLiyekunthah: 'ލިޔެކިޔުންތައް ބައްލަވާ',
    previewLoading: 'ތައްޔާރުވަނީ…',
    // Send-to-finance dialog
    sendDialogTitle: 'ފައިސާއަށް ފޮނުވުން',
    sendDialogIntro: 'ފައިސާއަށް ފޮނުވުމުގެ ކުރިން ޕަރޗޭސް އޯޑަރު އަޕްލޯޑްކުރައްވާ. ބޭނުންފުޅުނަމަ އިތުރު ލިޔެކިޔުންވެސް އެއްކުރެއްވިދާނެ.',
    otherDocsLabel: 'އިތުރު ލިޔެކިޔުން',
    // Goods received → vendor invoice confirmation handoff
    goodsReceivedTitle: 'މުދާ ލިބުނުކަން ރެކޯޑްކުރޭ',
    goodsReceivedConfirm: 'މުދާ ލިބިއްޖެ',
    goodsReceivedFailed: 'މުދާ ލިބުނުކަން ރެކޯޑްކުރުމުގައި މައްސަލައެއް',
    awaitingVendorConfirm: 'ވިއްކާ ފަރާތުގެ ޔަގީންކުރުމަށް',
    resendInvoiceLink: 'ލިންކް އަލުން ފޮނުވާ',
    resendInvoiceLinkSent: 'ލިންކް ފޮނުވިއްޖެ',
    resendInvoiceLinkFailed: 'ލިންކް ފޮނުވުމުގައި މައްސަލައެއް',
  },
  manualQuote: {
    // Mode chooser
    modeHeading: 'ކޯޓޭޝަން ހޯދާ ގޮތް',
    modeHint: 'އޮޓޮމެޓިކްކޮށް ވިއްކާ ފަރާތްތަކަށް ދައުވަތު ފޮނުވާ، ނުވަތަ ބޭރުން ހޯދާފައިވާ ކޯޓޭޝަންތައް އަމިއްލައަށް އަޕްލޯޑްކުރޭ.',
    modeAutomatic: 'އޮޓޮމެޓިކް ކޯޓޭޝަން',
    modeAutomaticHint: 'ވިއްކާ ފަރާތްތަކަށް ލިންކް ފޮނުވައި، އަގުތައް އަޅުވައި، އަޅާކިޔާ',
    modeManual: 'މެނުއަލް ކޯޓޭޝަން',
    modeManualHint: 'ކޯޓޭޝަންތަކާއި އިންވޮއިސް އަޕްލޯޑްކޮށް، ވިއްކާ ފަރާތާއި އަދަދު އަމިއްލައަށް ހޮވާ',
    switchToManual: 'މެނުއަލް ކޯޓޭޝަނަށް ބަދަލުކުރޭ',
    switchToAutomatic: 'އޮޓޮމެޓިކަށް އަނބުރާ',
    switchFailed: 'ބަދަލުކުރެވޭ ގޮތެއް ނުވިއެ',
    // Panel
    heading: 'މެނުއަލް ކޯޓޭޝަން',
    quotationsLabel: 'ކޯޓޭޝަންތައް',
    quotationsHint: 'ހޯދާފައިވާ ހުރިހާ ކޯޓޭޝަނެއް މިތަނަށް އަޕްލޯޑްކުރޭ (PDF ނުވަތަ ފޮޓޯ)',
    invoiceLabel: 'އިންވޮއިސް',
    invoiceHint: 'ހޮވި ފަރާތުގެ އިންވޮއިސް',
    addFile: 'ފައިލް އިތުރުކުރޭ',
    uploading: 'އަޕްލޯޑްވަނީ…',
    remove: 'ނަގާ',
    uploadFailed: 'ފައިލް ބަލައިނުގަނެވުނު',
    deleteFailed: 'ފައިލް ނުނެގުނު',
    // Award
    vendorLabel: 'ހޮވި ފަރާތް',
    vendorPlaceholder: 'ފަރާތެއް ހޮވާ',
    amountLabel: 'އަދަދު (ރ)',
    amountPlaceholder: 'ޖުމްލަ އަދަދު',
    awardBtn: 'ފަރާތް ކަނޑައަޅާ',
    awarding: 'ކަނޑައަޅަނީ…',
    awardFailed: 'ފަރާތް ކަނޑައެޅޭ ގޮތެއް ނުވިއެ. ކޯޓޭޝަނާއި އިންވޮއިސް އަދި އަދަދު ފުރިހަމަކުރޭ.',
    awardedTo: 'ފަރާތް ކަނޑައެޅި',
    amountRow: 'ޖުމްލަ',
    // Post-award: send for payment
    otherDocsLabel: 'އިތުރު ލިޔެކިޔުންތައް',
    otherDocsHint: 'ފައިސާ ދެއްކުމަށް ބޭނުންވާ އިތުރު ލިޔެކިޔުންތައް (ޚިޔާރީ)',
    sendForPayment: 'ފައިސާ ދައްކަން ފޮނުވާ',
    sending: 'ފޮނުވަނީ…',
    sendFailed: 'ފޮނުވޭ ގޮތެއް ނުވިއެ',
    sentToFinanceBadge: 'ފައިސާ ދައްކަން ފޮނުވިއްޖެ',
    paidBadge: 'ދައްކާފައި',
    previewPackage: 'ލިޔެކިޔުންތައް ބަލާ',
    previewLoading: 'ތައްޔާރުވަނީ…',
    loading: 'ލޯޑްވަނީ…',
  },
  payments: {
    navLabel: 'ފައިސާ',
    title: 'ފައިސާ',
    subtitle: 'ފައިސާ ދައްކަން ފޮނުވާފައިވާ ކޯންޓްރެކްޓްތައް',
    filterAll: 'ހުރިހާ',
    allYears: 'ހުރިހާ އަހަރެއް',
    yearLabel: 'އަހަރު',
    acctNumberLabel: 'އެކައުންޓް ނަންބަރު',
    acctNameLabel: 'އެކައުންޓް ނަން',
    searchPlaceholder: 'ފައިސާ ހޯދާ…',
    loading: 'ލޯޑްވަނީ…',
    loadError: 'ލޯޑް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    empty: 'ފައިސާ ދައްކަން ފޮނުވާފައިވާ އެއްޗެއް ނެތް.',
    // Table columns
    colTitle: 'ސުރުޚީ',
    colRef: 'ރެފް',
    colVendor: 'ވިއްކާ ފަރާތް',
    colAmount: 'އަގު',
    colSentAt: 'ފޮނުވި ތާރީޚު',
    colRefs: 'ރިކުއިޒިޝަން / ރިކުއެސްޓް',
    colStatus: 'ހާލަތު',
    gsrLabel: 'ރިކުއިޒިޝަން',
    prLabel: 'ރިކުއެސްޓް',
    // Status pills
    statusPaid: 'ފައިސާ ދައްކާފައި',
    statusPending: 'ފައިސާ ދައްކަން',
    // Actions
    documents: 'ލިޔެކިޔުންތައް',
    documentsTitle: 'ފައިސާގެ ލިޔެކިޔުންތައް (PDF) ޑައުންލޯޑްކުރޭ',
    opening: 'ހުޅުވަނީ…',
    markPaid: 'ފައިސާ ދައްކައިފިކަމަށް ފާހަގަކުރޭ',
    markUnpaid: 'ފައިސާ ނުދައްކާކަމަށް ފާހަގަކުރޭ',
    updating: 'ބަދަލުކުރަނީ…',
    updateFailed: 'ފައިސާގެ ހާލަތު ބަދަލެއް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    paidAt: 'ދެއްކި ތާރީޚު',
    vendorConfirmedMarker: 'ވިއްކާ ފަރާތުން ޔަގީންކުރި',
    // Mark-as-paid dialog: payment documents
    markPaidTitle: 'ފައިސާ ދެއްކުމުގެ ލިޔެކިޔުންތައް',
    markPaidIntro: 'ފައިސާ ދައްކައިފިކަމަށް ފާހަގަކުރެއްވުމުގެ ކުރިން ޕޭމަންޓް ވައުޗަރާއި ޕޭމަންޓް ސްލިޕް އަޕްލޯޑްކުރައްވާ.',
    pvLabel: 'ޕޭމަންޓް ވައުޗަރު',
    slipLabel: 'ޕޭމަންޓް ސްލިޕް',
    otherLabel: 'އިތުރު ލިޔެކިޔުން',
    docUploadBtn: 'ފައިލް ހޮއްވަވާ',
    docReplaceBtn: 'ބަދަލުކުރައްވާ',
    docUploading: 'އަޕްލޯޑްވަނީ…',
    docRemove: 'ނަގާ',
    docNone: 'ފައިލެއް ނެތް',
    docInvalid: 'ފައިލެއް ބަލައިނުގަނެވުނު. PDF ނުވަތަ ފޮޓޯ (PNG/JPG) ބޭނުންކުރައްވާ.',
    previewPackage: 'ލިޔެކިޔުންތައް ބައްލަވާ',
    previewLoading: 'ތައްޔާރުވަނީ…',
    confirmMarkPaid: 'ފައިސާ ދައްކައިފި',
    docsRequiredHint: 'ޕޭމަންޓް ވައުޗަރާއި ސްލިޕް ދެ ފައިލް ބޭނުންވޭ.',
    cancel: 'ކެންސަލް',
  },
  gsr: {
    // List page
    title: 'ތަކެތި/ޚިދުމަތް ރިކުއިޒިޝަން',
    newGsr: 'އައު ރިކުއިޒިޝަން',
    // Toolbar (filter pills + status select + search)
    filterAll: 'ހުރިހާ',
    allStatuses: 'ހުރިހާ ހާލަތެއް',
    allYears: 'ހުރިހާ އަހަރެއް',
    yearLabel: 'އަހަރު',
    // Pending-action filter (procurement to-do tracker)
    pendingLabel: 'ފުރިހަމަކުރަންޖެހޭ',
    pendingAll: 'ފުރިހަމަކުރަންޖެހޭ — ހުރިހާ',
    pendingNeedsQuotation: 'އަގުބަލަން ޖެހޭ',
    pendingAwardedNotSent: 'ފައިސާ ދައްކަން ޖެހޭ',
    searchPlaceholder: 'ރިކުއިޒިޝަން ހޯދާ…',
    // Table columns
    colNumber: 'ނަންބަރު',
    colType: 'ބާވަތް',
    colStatus: 'ހާލަތު',
    colSection: 'ސެކްޝަން',
    colDate: 'ތާރީޚު',
    colView: 'ބަލާ',
    // Loading / empty states
    loading: 'ލޯޑްވަނީ…',
    empty: 'އަދި ރިކުއިޒިޝަނެއް ނެތް. މަތިން ހަދައިލާ.',
    // Status labels (enum: DRAFT / PENDING_SIGNATURE / APPROVED / RFQ_GENERATED)
    statusDraft: 'ޑްރާފްޓް',
    statusPendingSignature: 'ސޮއި ބޭނުންވޭ',
    statusApproved: 'ފާސްކޮށްފި',
    statusRfqGenerated: 'ކޯޓޭޝަން ހޯދަނީ',
    // Derived statuses from the linked RFQ's award/payment state
    statusContracted: 'ކޮންޓްރެކްޓް ކޮށްފި',
    statusPaying: 'ފައިސާ ދައްކަނީ',
    statusPaid: 'ފައިސާ ދައްކައިފި',
    // Type labels (enum: GOODS / SERVICE)
    typeGoods: 'ތަކެތި',
    typeService: 'ޚިދުމަތް',
    // Create form
    createTitle: 'އައު ރިކުއިޒިޝަން',
    createSubtitle: 'ބޭނުންވާ ތަކެތި ނުވަތަ ޚިދުމަތް ލިޔެ ހުށަހަޅާ.',
    typeLabel: 'ބާވަތް',
    typeGoods2: 'ތަކެތި',
    typeService2: 'ޚިދުމަތް',
    sectionLabel: 'ސެކްޝަން',
    sectionPlaceholder: 'ސެކްޝަންގެ ނަން',
    // Items table
    itemsSectionTitle: 'ތަފްސީލު',
    colParticulars: 'ތަފްސީލު',
    colQtyRequested: 'އަދަދު',
    colUnit: 'ހަމަ',
    colRequiredDate: 'ތާރީޚު',
    colRemarks: 'ތަފްސީލު (އިތުރު)',
    placeholderParticulars: 'ތަކެތި/ޚިދުމަތުގެ ތަފްސީލު',
    placeholderQty: 'އަދަދު',
    placeholderUnit: 'ޕީސް، ކިލޯ…',
    placeholderRequiredDate: 'ތާރީޚު',
    placeholderRemarks: 'ތަފްސީލު (އިޚްތިޔާރީ)',
    ariaParticulars: 'ތަފްސީލު',
    ariaQty: 'ބޭނުންވާ އަދަދު',
    ariaUnit: 'ހަމަ',
    ariaRequiredDate: 'ބޭނުންވާ ތާރީޚު',
    ariaRemarks: 'ތަފްސީލު (އިތުރު)',
    ariaRemove: 'ސަފްޙާ ނަގާ',
    addRow: 'ތަފްސީލު އިތުރުކުރޭ',
    submit: 'ހުށަހަޅާ',
    submitting: 'ހުށަހަޅަނީ…',
    cancel: 'ކެންސަލް',
    errorNoItems: 'ތަފްސީލާއި، ހަމައާއި، އަދަދު ހިމެނޭ ތަކެތި ވަދެ ފުރިހަމަ ކުރޭ.',
    errorFailed: 'ރިކުއިޒިޝަން ހެދޭ ގޮތް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    // GSR number (manual) + sign-off people
    numberLabel: 'ޖީ.އެސް.އާރު ނަންބަރު',
    numberPlaceholder: 'މިސާލު: MG/PC01/2026/12',
    thafseelLabel: 'ތަފްޞީލު',
    thafseelPlaceholder: 'ބޭނުންވާ ތަކެތި/ޚިދުމަތުގެ ކުރު ތަފްޞީލެއް',
    errorTitleRequired: 'ތަފްޞީލު ލިޔުއްވާ.',
    signoffSectionTitle: 'ސޮއި ކުރައްވާ ފަރާތްތައް',
    requestedByLabel: 'އެދުނު ފަރާތް',
    approvedByLabel: 'ހުއްދަދެއްވި ފަރާތް',
    selectPerson: 'ފަރާތެއް ހޮއްވަވާ…',
    requestedByHint: 'ނުހޮއްވަވައިފިނަމަ، ރިކުއިޒިޝަން ހެއްދެވި ފަރާތް.',
    errorNumberRequired: 'ޖީ.އެސް.އާރު ނަންބަރު ޖައްސަވާ.',
    errorApproverRequired: 'ހުއްދަދެއްވި ފަރާތް ހޮއްވަވާ.',
    errorNumberTaken: 'މި ނަންބަރު ކުރިންވެސް ބޭނުންކޮށްފައިވޭ. އެހެން ނަންބަރެއް ޖައްސަވާ.',
  },
  gsrDetail: {
    loading: 'ލޯޑްވަނީ…',
    notFound: 'ރިކުއިޒިޝަނެއް ނެތް.',
    ariaBack: 'ރިކުއިޒިޝަންތަކަށް ދޭ',
    createdAt: 'ތައްޔާރުކުރި',
    itemsHeading: 'ތަފްސީލު',
    colNum: '#',
    colParticulars: 'ތަފްސީލު',
    colQty: 'އަދަދު',
    colUnit: 'ހަމަ',
    colRequiredDate: 'ތާރީޚު',
    colRemarks: 'ތަފްސީލު (އިތުރު)',
    // Status
    statusDraft: 'ޑްރާފްޓް',
    statusPendingSignature: 'ސޮއި ބޭނުންވޭ',
    statusApproved: 'ފާސްކޮށްފި',
    statusRfqGenerated: 'ކޯޓޭޝަން ހޯދަނީ',
    // Type
    typeGoods: 'ތަކެތި',
    typeService: 'ޚިދުމަތް',
    // Actions
    downloadPdf: 'GSR PDF ޑައުންލޯޑް',
    sendToSign: 'ސޮއިކުރަން ފޮނުވާ',
    sending: 'ފޮނުވަނީ…',
    createPr: 'ތަކެތި ގަތުމުގެ ރިކުއެސްޓް ހަދާ',
    creatingPr: 'ހަދަނީ…',
    generateRfq: 'ކޯޓޭޝަން ހޯދަން ފަށާ',
    generatingRfq: 'ހަދަނީ…',
    errorSend: 'ފޮނުވޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    errorCreatePr: 'ރިކުއެސްޓް ހެދޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    errorGenerateRfq: 'ކޯޓޭޝަން ހޯދަން ފެށޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    section: 'ސެކްޝަން',
    gsrNumber: 'ނަންބަރު',
    type: 'ބާވަތް',
    // Tab labels and lock hint
    tabs: {
      requisition: 'މުދާ/ޚިދުމަތަށް އެދުން',
      purchaseRequest: 'މުދާ ގަންނަން އެދުން',
      quotation: 'އަގުބެލުން',
      lockHint: 'ކުރީ ފިޔަވަހި ފުރިހަމަ ކުރޭ',
    },
    // Signing continuation and withdrawal
    continueSigning: 'ސޮއި ކުރިޔަށް ދޭ',
    withdraw: 'ސޮއި ހޯދުން އަނބުރާ ގެންދޭ',
    withdrawing: 'ގެންދަނީ…',
    errorWithdraw: 'ހޯދুুން ހުއްޓޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    approvedBadge: 'ފާސްކޮށްފި',
    // Tab 2 (PR)
    noPrYet: 'ތަކެތި ގަތުމުގެ ރިކުއެސްޓް ތައްޔާރުކޮށްފައި ނެތް.',
    createPrAction: 'ތަކެތި ގަތުމުގެ ރިކުއެސްޓް ހަދާ',
    // Tab 3 (RFQ)
    noRfqYet: 'ކޯޓޭޝަން ހޯދުން ތައްޔާރުކޮށްފައި ނެތް.',
    generateRfqAction: 'ކޯޓޭޝަން ހޯދަން ފަށާ',
  },
  // Stockkeeper's PR preparation form (enter PR number + current stock, then generate).
  prPrepare: {
    intro: 'ސްޓޮކްގައި މިހާރު ހުރި ޢަދަދު ފުރިހަމަކުރައްވައި، ފޯމް ތައްޔާރު ކުރައްވާ.',
    numberLabel: 'ޕީ.އާރު ނަންބަރު',
    numberPlaceholder: 'މިސާލު: PR/2026/12',
    colNum: '#',
    colDescription: 'ތަފްސީލު',
    colQtyRequired: 'ބޭނުންވާ',
    colStock: 'ސްޓޮކްގައި',
    stockkeeperLabel: 'ސްޓޮކްއާ ޙަވާލުވެހުރި ފަރާތް',
    selectStockkeeper: 'ފަރާތެއް ހޮއްވަވާ…',
    generate: 'ފޯމް ތައްޔާރު ކުރޭ',
    generating: 'ތައްޔާރު ކުރަނީ…',
    errorNumberRequired: 'ޕީ.އާރު ނަންބަރު ޖައްސަވާ.',
    errorStockkeeperRequired: 'ސްޓޮކްއާ ޙަވާލުވެހުރި ފަރާތް ހޮއްވަވާ.',
    errorStockRequired: 'ހުރިހާ ތަކެއްޗެއްގެ ސްޓޮކް ޢަދަދު ފުރިހަމަކުރައްވާ.',
    errorNumberTaken: 'މި ނަންބަރު ކުރިންވެސް ބޭނުންކޮށްފައިވޭ. އެހެން ނަންބަރެއް ޖައްސަވާ.',
    errorFailed: 'ފޯމް ތައްޔާރު ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
  },
  prDetail: {
    loading: 'ލޯޑްވަނީ…',
    notFound: 'ތަކެތި ގަތުމުގެ ރިކުއެސްޓެއް ނެތް.',
    ariaBack: 'ރިކުއިޒިޝަންތަކަށް ދޭ',
    createdAt: 'ތައްޔާރުކުރި',
    heading: 'ތަކެތި ގަތުމުގެ ރިކުއެސްޓް',
    prNumber: 'ނަންބަރު',
    itemsHeading: 'ތަފްސީލު',
    colNum: '#',
    colDescription: 'ތަފްސީލު',
    colQtyRequired: 'ބޭނުންވާ',
    colQtyInStock: 'ސްޓޮކްގައި',
    colDepartment: 'ސެކްޝަން',
    colRequiredDate: 'ތާރީޚު',
    // Status
    statusDraft: 'ޑްރާފްޓް',
    statusPendingSignature: 'ސޮއި ބޭނުންވޭ',
    statusApproved: 'ފާސްކޮށްފި',
    // Actions
    downloadPdf: 'PR PDF ޑައުންލޯޑް',
    sendToSign: 'ސޮއިކުރަން ފޮނުވާ',
    sending: 'ފޮނުވަނީ…',
    saving: 'ސޭވްކުރަނީ…',
    saveChanges: 'ބަދަލު ސޭވްކުރޭ',
    errorSend: 'ފޮނުވޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    errorSave: 'ބަދަލު ސޭވްނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    ariaSaveRow: 'ބަދަލު ސޭވްކުރޭ',
    section: 'ސެކްޝަން',
    // Signing continuation and withdrawal
    continueSigning: 'ސޮއި ކުރިޔަށް ދޭ',
    withdraw: 'ސޮއި ހޯދުން އަނބުރާ ގެންދޭ',
    withdrawing: 'ގެންދަނީ…',
    errorWithdraw: 'ހޯދুুން ހުއްޓޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    approvedBadge: 'ފާސްކޮށްފި',
  },
  orgSettings: {
    loading: 'ލޯޑްވަނީ…',
    heading: 'ޖަމިއްޔާގެ ސެޓިންގ',
    letterheadHint: 'މި ލެޓަރހެޑް ބޭނުންކުރެވޭނީ ތައްޔާރުކުރާ ޑޮކިއުމަންޓްތަކުގައެވެ.',
    headerImageLabel: 'ލެޓަރހެޑް ބޭލިމަތި',
    footerImageLabel: 'ލެޓަރހެޑް ތިރި',
    footerTextLabel: 'ފޫޓަރ ލިޔުން',
    footerTextPlaceholder: 'ލިޔުން',
    currentImage: 'ހިމެނިފައި',
    noImage: 'ފޮޓޯ ލެވިފައި ނެތް',
    uploadBtn: 'ފޮޓޯ ބަދަލުކުރޭ',
    uploadHint: 'PNG ، JPEG ، ގިނަވެ 2 MB',
    saveFooterText: 'ލިޔުން ސޭވްކުރޭ',
    saving: 'ސޭވްކުރަނީ…',
    savedOk: 'ސޭވްކޮށްފި.',
    errorSave: 'ސޭވްނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    errorFileSize: 'ފޮޓޯ 2 MB ތަށް ބޮޑެއް.',
    errorFileType: 'PNG ، JPEG ގެ ފޮޓޯ ހިޔާރުކުރޭ.',
    ariaUploadHeader: 'ލެޓަރހެޑް ބޭލިމަތި ފޮޓޯ ހިޔާރުކުރޭ',
    ariaUploadFooter: 'ލެޓަރހެޑް ތިރި ފޮޓޯ ހިޔާރުކުރޭ',
    navLabel: 'ސެޓިންގ',
    // SMS (Dhiraagu)
    smsHeading: 'SMS (Dhiraagu Bulk SMS)',
    smsUsernameLabel: 'Username',
    smsPasswordLabel: 'Password',
    smsPasswordPlaceholderSaved: '•••••••• (saved)',
    smsPasswordPlaceholderEmpty: 'Password',
    smsEnabledLabel: 'SMS ފޮނުވުން ހުޅުވާ',
    smsSaveBtn: 'SMS ސެޓިންގ ސޭވްކުރޭ',
    smsSavedOk: 'ސޭވްކޮށްފި.',
    smsErrorSave: 'ސޭވްނުވިއެ. ދެން ތިޔަ ކުރޭ.',
    smsTestHeading: 'ޓެސްޓް SMS ފޮނުވާ',
    smsTestPhonePlaceholder: 'ފޯން ނަންބަރު',
    smsTestBtn: 'ޓެސްޓް ފޮނުވާ',
    smsTestSending: 'ފޮނުވަނީ…',
    smsTestOk: (id: string) => `ފޮނުވިއްޖެ. Message ID: ${id}`,
    smsTestError: 'ފޮނުވޭ ގޮތެއް ނުވިއެ. ދެން ތިޔަ ކުރޭ.',
  },
  specDoc: {
    label: 'ސްޕެސިފިކޭޝަން ޑޮކިއުމަންޓް',
    hint: 'ވިއްކާ ފަރާތްތަކަށް ފެންނަ، ޑައުންލޯޑްކުރެވޭ ޑޮކިއުމަންޓެއް (ޚިޔާރީ)',
    add: 'ޑޮކިއުމަންޓް އަޕްލޯޑްކުރޭ',
    replace: 'ބަދަލުކުރޭ',
    uploading: 'އަޕްލޯޑްވަނީ…',
    remove: 'ނަގާ',
    uploadFailed: 'ފައިލް ބަލައިނުގަނެވުނު',
    deleteFailed: 'ފައިލް ނުނެގުނު',
  },
  smsMessages: {
    heading: 'ވިއްކާ ފަރާތްތަކަށް ފޮނުވާ SMS',
    intro: 'ކޮންމެ މެސެޖެއް ބޭނުން ގޮތަކަށް ބަދަލުކުރެވިދާނެ. ހުސްކޮށް ބެހެއްޓުމުން ސިސްޓަމްގެ ޑިފޯލްޓް މެސެޖް ބޭނުންކުރެވޭނެ.',
    tokensLabel: 'ބޭނުންކުރެވޭ ބައިތައް (ފިއްތާލުމުން އިތުރުކުރެވޭ)',
    previewLabel: 'ފެންނާނެ ގޮތް',
    save: 'ރައްކާކުރޭ',
    saving: 'ރައްކާކުރަނީ…',
    saved: 'ރައްކާކުރެވިއްޖެ',
    reset: 'ޑިފޯލްޓަށް',
    usingDefault: 'ޑިފޯލްޓް މެސެޖް ބޭނުންކުރަނީ',
    saveFailed: 'ރައްކާނުކުރެވުނު',
    loading: 'ލޯޑްވަނީ…',
    kind: {
      INVITE: 'ދައުވަތު (ކޯޓޭޝަން ހޯދުން)',
      WINNER: 'ހޮވުނު ފަރާތަށް',
      NOT_SELECTED: 'ނުހޮވުނު ފަރާތްތަކަށް',
      INVOICE_CONFIRM: 'އިންވޮއިސް ޔަގީންކުރުން',
      INVOICE_PAID: 'ފައިސާ ދެއްކުން',
    } as Record<string, string>,
    token: {
      council: 'ކައުންސިލްގެ ނަން',
      ref: 'ރިކުއެސްޓް ނަންބަރު',
      gsrNumber: 'GSR ނަންބަރު',
      deadline: 'ސުންގަޑި',
      requiredDate: 'ބޭނުންވާ ތާރީޚު',
      deliverBy: 'ގެނެސްދޭންވީ ތާރީޚު',
      vendor: 'ވިއްކާ ފަރާތުގެ ނަން',
      url: 'ލިންކް',
    } as Record<string, string>,
  },
  notFound: {
    heading: '404',
    body: 'ޞަފްޙާ ނުފެނުނު.',
    goHome: 'ޑޭޝްބޯޑަށް ދޭ',
  },
  sso: {
    signingIn: 'ވަންނަނީ…',
    invalidLink: 'ލިންކް ސައްޙައެއް ނޫން. ދެން ތިޔަ ކުރޭ.',
  },
  // Labels of the quotation DOCUMENT itself. Every string here is copied
  // verbatim from backend/src/templates/quote/quotation.html so the on-screen
  // pricing sheet and the generated PDF read identically. If you change the
  // template, change these too — and never translate one without the other.
  quotationDoc: {
    title: 'ކޯޓޭޝަން',
    refNumber: 'ރެފް ނަންބަރު:',
    date: 'ތާރީޚު:',
    phone: 'ފޯނު:',
    toLabel: 'ފޮނުވާ ފަރާތް',
    // Item table column headers, in the template's column order.
    colItem: 'ތަކެތި',
    colQty: 'އަދަދު',
    colUnit: 'ހަމަ',
    colRate: 'ރޭޓު (MVR)',
    colLineTotal: 'ޖުމްލަ (MVR)',
    grandTotal: 'ޖުމްލަ (MVR)',
  },

  publicQuote: {
    // Shell header
    vendorQuoteForm: 'ވިއްކާ ފަރާތްތަކުގެ ކޯޓޭޝަން ފޯމް',

    // Request header labels
    statusOpen: 'ހުޅުވިފައި',
    deadline: 'ސުންގަޑި:',
    vendor: 'ވިއްކާ ފަރާތް:',
    specDocLabel: 'ސްޕެސިފިކޭޝަން ޑޮކިއުމަންޓް ޑައުންލޯޑްކުރޭ',

    // Items section
    itemsHeading: (n: number) => `ތަކެތި (${n})`,

    // Price input label & "no quote" toggle
    unitPriceMvr: 'އެއިން ތަކެތި (MVR)',
    noQuote: 'ހުށަހަޅަން ބޭނުންނޫން',

    // Line subtotal — assembled in JSX (MVR kept Latin, operands in .num)
    // ID card field
    idCardLabel: 'އައިޑީ ކާޑު ނަންބަރު',
    idCardPlaceholder: 'ފޯމެޓް: A123456',
    idCardHint: (vendorName: string) =>
      `${vendorName} ގެ ނަމުގައި ރެޖިސްޓްރީ ކޮށްފައިވާ އައިޑީ ކާޑު ނަންބަރު ލިޔޭ.`,

    // Declaration checkbox
    declarationText: (vendorName: string) =>
      `ތިރީގައި ހުށަހެޅި އަގުތަކަކީ ${vendorName} ގެ ނަމުގައި ހުުށަހެޅާ ތެދު، ރަނގަޅު، ސައްޙަ އަދި ފުރިހަމަ އަގުތަކެއްކަން ތިމަންނަ/ތިމަންމެން އިޤްރާރުވެ ތެދުވެރިކަމާ އެކު ހުުށަހަޅަމެވެ.`,

    // Running total label
    estimatedTotal: 'ލަފާ ޖުމްލަ',

    // Submit button states
    submit: 'ހުށަހަޅާ',
    submitting: 'ހުށަހަޅަނީ…',

    // Disclaimer under submit
    submitOnce: 'ހުުށަހެޅެނީ އެންމެ ފަހަރަކު. ހުުށަހެޅުމުގެ ކުރިން ހުރިހާ އަގެއް ބަލައި ޔަގީންކުރޭ.',

    // ── State screens ─────────────────────────────────────────────────────────

    // Loading
    loadingForm: 'ފޯމް ލޯޑްވަނީ…',

    // Invalid / expired link
    invalidLinkTitle: 'ލިންކް ސައްޙައެއް ނޫން ނުވަތަ މުއްދަތު ހަމަވެއްޖެ.',

    // Success / thank-you screen
    thankYouTitle: (vendorName: string) => `ޝުކުރިއްޔާ، ${vendorName}!`,
    thankYouBody: (requestTitle: string, refNumber: string) =>
      `${requestTitle} (${refNumber}) ގެ ކޯޓޭޝަން ލިބިއްޖެ. ހުރިހާ ހުުށަހެޅުންތައް ރިވިއު ކުރުމަށްފަހު ކައުންސިލުން ގުޅާނެ.`,

    // Already submitted
    alreadySubmittedTitle: 'ކޯޓޭޝަން ލިބިއްޖެ',
    alreadySubmittedBody: (requestTitle: string, refNumber: string) =>
      `${requestTitle} (${refNumber}) ގެ ކޯޓޭޝަން ތިޔަ ހުުށަހަޅުއްވައިފިއެވެ.`,

    // Closed request
    closedTitle: 'ރިކުއެސްޓް ބަންދު',
    closedBody: (requestTitle: string, refNumber: string) =>
      `${requestTitle} (${refNumber}) ގައި ދެން ކޯޓޭޝަން ހުުށަހެޅޭ ގޮތެއް ނެތް.`,

    // Error messages keyed by SubmitErrorCode
    errIdCardMismatch: 'ދިން އައިޑީ ކާޑު ނަންބަރު ދިމައެއް ނޫން.',
    errAlreadySubmitted: 'ތިޔަ ވިއްކާ ފަރާތުން ކޯޓޭޝަން ހުުށަހަޅައިފި.',
    errRequestClosed: 'ރިކުއެސްޓް ބަންދުވެ ކޯޓޭޝަން ހުުށަހެޅޭ ގޮތެއް ނެތް.',
    errNoPrices: 'ވަދެ ތަންކޮޅެއް ތަކެއްޗެއްގެ އަގު ލިޔޭ.',
    errDeclarationRequired: 'ހުުށަހެޅުުމުުގެ ކުރިން ތިރީ ޖެހި ފޮށި ފިތޭ.',
    errInvalidPrice: 'ލިޔެފައިވާ އަގުތައް ފަހުން ބަލާ.',
    errNotFound: 'ލިންކް ސައްޙައެއް ނޫން ނުވަތަ މުުއްދަތު ހަމަވެއްޖެ.',
    errGeneral: 'ކޮންމެ ވެސް ގޯހެއް ދިމާވެއްޖެ. ދެން ތިޔަ ކުރޭ.',
  },
  invoiceConfirm: {
    // Shell header
    pageTitle: 'އިންވޮއިސް ޔަގީންކުރުން',

    // Loading
    loadingForm: 'ލޯޑްވަނީ…',

    // Invalid / expired link
    invalidLinkTitle: 'ލިންކް ސައްޙައެއް ނޫން',
    expiredLinkTitle: 'ލިންކް މުއްދަތު ހަމަވެއްޖެ',

    // Already confirmed (read-only) screen
    alreadyConfirmedTitle: 'މި އިންވޮއިސް ކުރިން ޔަގީންކޮށްފައިވޭ',
    alreadyConfirmedBody: (refNumber: number) =>
      `ރެފަރެންސް ނަންބަރު ${refNumber} ގެ އިންވޮއިސް ކުރިން ޔަގީންކޮށްފައިވޭ. އިތުރު ފިޔަވަޅެއް އަޅާކަށް ނުޖެހޭ.`,

    // Invoice summary
    refNumber: 'ރެފް ނަންބަރު:',
    vendor: 'ވިއްކާ ފަރާތް:',
    itemsHeading: (n: number) => `ތަކެތި (${n})`,
    colItem: 'ތަކެތި',
    colQty: 'އަދަދު',
    colUnit: 'ހަމަ',
    colUnitPrice: 'އެއިން އަގު (MVR)',
    colLineTotal: 'ޖުމްލަ (MVR)',
    grandTotal: 'ޖުމްލަ',

    // Bank account
    bankHeading: 'ބޭންކް އެކައުންޓް',
    bankAccountName: 'އެކައުންޓް ނަން',
    bankAccountNumber: 'އެކައުންޓް ނަންބަރު',
    bankNotSet: 'ރެޖިސްޓްރީކޮށްފައި ނެތް',
    changeBankToggle: 'އެކައުންޓް ބަދަލުކުރޭ',
    newBankAccountName: 'އައު އެކައުންޓް ނަން',
    newBankAccountNumber: 'އައު އެކައުންޓް ނަންބަރު',

    // ID card
    idCardLabel: 'އައިޑީ ކާޑު ނަންބަރު',
    idCardPlaceholder: 'ފޯމެޓް: A123456',

    // Signature pad
    signatureHeading: 'ސޮއި',
    signatureHint: 'ތިރީ ސަރަޙައްދުގައި އިނގިލިން ނުވަތަ މައުސް އިން ސޮއިކުރޭ.',
    signatureClear: 'ސާފުކުރޭ',

    // Submit
    submit: 'ޔަގީންކުރޭ',
    submitting: 'ފޮނުވަނީ…',

    // Error messages keyed by HTTP status
    errIdCardMismatch: 'އައިޑީ ކާޑް ދިމައެއް ނުވޭ.',
    errLinkExpired: 'ލިންކް މުއްދަތު ހަމަވެއްޖެ.',
    errAlreadyConfirmed: 'މި އިންވޮއިސް ކުރިން ޔަގީންކޮށްފައިވޭ.',
    errInvalidSignature: 'ސޮއި ނުވަތަ މައުލޫމާތު ސައްހައެއް ނޫން.',
    errGeneral: 'ކޮންމެ ވެސް ގޯހެއް ދިމާވެއްޖެ. ދެން ތިޔަ ކުރޭ.',

    // Success screen
    successTitle: 'ޝުކުރިއްޔާ!',
    successBody: 'އިންވޮއިސް ޔަގީންކުރެވިއްޖެ.',
  },
  invoiceSlip: {
    // Shell header
    pageTitle: 'ޓްރާންސްފަރ ސްލިޕް',

    // Loading
    loadingForm: 'ލޯޑްވަނީ…',

    // Invalid link
    invalidLinkTitle: 'ލިންކް ސައްޙައެއް ނޫން',

    // Paid state
    paidTitle: (refNumber: number) => `ބިލް ނަންބަރު ${refNumber} އަށް ފައިސާ ދައްކައިފި`,
    paidAtLabel: 'ފައިސާ ދެއްކި ތާރީޚު:',
    viewSlip: 'ޓްރާންސްފަރ ސްލިޕް ބައްލަވާ',

    // Not-yet-paid state
    notPaidTitle: 'މި ބިލަށް އަދި ފައިސާ ނުދައްކާ',
  },
  vendorPortal: {
    // ── Login ─────────────────────────────────────────────────────────────────
    brand: 'WapPro',
    brandSubtitle: 'ވިއްކާ ފަރާތްތަކުގެ ޕޯޓަލް',
    loginTitle: 'ވިއްކާ ފަރާތުގެ ލޮގިން',
    loginSubtitle: 'އައިޑީ ކާޑު ނަންބަރާއި ޕާސްވޯޑް ލިޔެ ވަދޭ.',
    idCard: 'އައިޑީ ކާޑު ނަންބަރު',
    idCardPlaceholder: 'A123456',
    password: 'ޕާސްވޯޑް',
    showPassword: 'ޕާސްވޯޑް ދައްކާ',
    hidePassword: 'ޕާސްވޯޑް ފޮރުވާ',
    loginSubmit: 'ވަދޭ',
    loggingIn: 'ވަންނަނީ…',
    errInvalid: 'އައިޑީ ކާޑު ނަންބަރު ނުވަތަ ޕާސްވޯޑް ރަނގަޅެއް ނޫން.',
    errGeneral: 'ކޮންމެވެސް ގޯހެއް ވެއްޖެ. ދެން ތިޔަ ކުރޭ.',

    // ── Layout / nav ────────────────────────────────────────────────────────
    navQuotations: 'އަހަރެންގެ ކޯޓޭޝަން',
    navOpen: 'ހުޅުވިފައިވާ ރިކުއެސްޓް',
    navAwards: 'ލިބުނު ކޯންޓްރެކްޓް',
    logout: 'ލޮގްއައުޓް',
    ecosystemLink: 'ވެޕްލިފައި އޮފީސް',

    // ── Quotations list ─────────────────────────────────────────────────────
    quotationsTitle: 'އަހަރެންގެ ކޯޓޭޝަން',
    loading: 'ލޯޑްވަނީ…',
    loadError: 'ލޯޑް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    quotationsEmpty: 'އަދި ކޯޓޭޝަން ހުށަހަޅާފައި ނެތް.',
    submittedAt: 'ހުށަހެޅި',
    deadline: 'ސުންގަޑި',
    colItem: 'ތަކެތި',
    colQty: 'އަދަދު',
    colUnit: 'ހަމަ',
    colUnitPrice: 'އެއިން އަގު (MVR)',
    noPrice: '—',
    statusSubmitted: 'ހުށަހަޅައިފި',
    statusWon: 'ލިބުނު',
    statusLost: 'ނުލިބުނު',
    statusPending: 'ނިންމަން ހުރި',
    viewPdf: 'ބަލާ',
    downloadPdf: 'ޑައުންލޯޑް',
    pdfError: 'PDF ނުފެނުނު. ދެން ތިޔަ ކުރޭ.',

    // ── List toolbars (search / filters, shared across quotations/awards/open) ─
    searchPlaceholder: 'ހޯދާ (ނަން ނުވަތަ ނަންބަރު)',
    colStatus: 'ހާލަތު',
    filterAllStatuses: 'ހުރިހާ ހާލަތެއް',
    filterAll: 'ހުރިހާ',

    // ── Open requests + submit ──────────────────────────────────────────────
    openTitle: 'ހުޅުވިފައިވާ ރިކުއެސްޓް',
    openEmpty: 'މިވަގުތު ހުޅުވިފައިވާ ރިކުއެސްޓެއް ނެތް.',
    itemsHeading: (n: number) => `ތަކެތި (${n})`,
    fillQuote: 'ކޯޓޭޝަން ހުށަހަޅާ',
    closeForm: 'ފޯމް ބަންދުކުރޭ',
    unitPriceMvr: 'އެއިން ތަކެތި (MVR)',
    noQuote: 'ހުށަހަޅަން ބޭނުންނޫން',
    estimatedTotal: 'ލަފާ ޖުމްލަ',
    declarationText: (vendorName: string) =>
      `ތިރީގައި ހުށަހެޅި އަގުތަކަކީ ${vendorName} ގެ ނަމުގައި ހުށަހަޅާ ތެދު، ރަނގަޅު، ސައްޙަ އަދި ފުރިހަމަ އަގުތަކެއްކަން ތިމަންނަ/ތިމަންމެން އިޤްރާރުވެ ތެދުވެރިކަމާ އެކު ހުށަހަޅަމެވެ.`,
    submit: 'ހުށަހަޅާ',
    submitting: 'ހުށަހަޅަނީ…',
    submitOnce: 'ހުށަހެޅެނީ އެންމެ ފަހަރަކު. ހުށަހެޅުމުގެ ކުރިން ހުރިހާ އަގެއް ބަލައި ޔަގީންކުރޭ.',
    submitSuccess: 'ކޯޓޭޝަން ލިބިއްޖެ. ޝުކުރިއްޔާ!',

    // Submit errors (keyed by { error } code)
    errDeadlinePassed: 'ސުންގަޑި ހަމަވެ ކޯޓޭޝަން ހުށަހެޅޭ ގޮތެއް ނެތް.',
    errAlreadySubmitted: 'މި ރިކުއެސްޓަށް ކުރިން ކޯޓޭޝަން ހުށަހަޅައިފި.',
    errRequestClosed: 'ރިކުއެސްޓް ބަންދުވެ ކޯޓޭޝަން ހުށަހެޅޭ ގޮތެއް ނެތް.',
    errDeclarationRequired: 'ހުށަހެޅުމުގެ ކުރިން ތިރީ ޖެހި ފޮށި ފިތޭ.',
    errNoPrices: 'ވަދެ ތަންކޮޅެއް ތަކެއްޗެއްގެ އަގު ލިޔޭ.',
    errInvalidPrice: 'ލިޔެފައިވާ އަގުތައް ފަހުން ބަލާ.',
    errNotFound: 'ރިކުއެސްޓް ނުފެނުނު.',
    errSubmitGeneral: 'ކޮންމެވެސް ގޯހެއް ވެއްޖެ. ދެން ތިޔަ ކުރޭ.',

    // ── Awards ──────────────────────────────────────────────────────────────
    awardsTitle: 'ލިބުނު ކޯންޓްރެކްޓް',
    awardsEmpty: 'އަދި ކޯންޓްރެކްޓެއް ނުލިބޭ.',
    awardedAt: 'ދިން ތާރީޚު',
    amount: 'އަގު',
    paid: 'ފައިސާ ދައްކައިފި',
    unpaid: 'ފައިސާ ނުދައްކާ',

    // ── Request detail (drill-in) ────────────────────────────────────────────
    detailLoading: 'ލޯޑްވަނީ…',
    detailError: 'ލޯޑް ނުކުރެވުނު. ދެން ތިޔަ ކުރޭ.',
    detailNotFound: 'ރިކުއެސްޓެއް ނެތް.',
    ariaBack: 'ފަހަތަށް ދޭ',
    detailDeadline: 'ސުންގަޑި',
    // Request status (raw enum DRAFT/SENT/CLOSED — mirrors requestDetail.status*)
    reqStatusDraft: 'ޑްރާފްޓް',
    reqStatusSent: 'ފޮނުވާފައި',
    reqStatusClosed: 'ބަންދު',
    // Quotation section
    quotationHeading: 'ކޯޓޭޝަން',
    colLineItem: 'ތަކެތި',
    colLineQty: 'އަދަދު',
    colLineUnitPrice: 'އެއިން އަގު',
    colLineTotal: 'ޖުމްލަ',
    grandTotal: 'ޖުމްލަ އަގު',
    viewQuotation: 'ކޯޓޭޝަން ބަލާ',
    downloadQuotation: 'ކޯޓޭޝަން ޑައުންލޯޑް',
    pdfOpenError: 'PDF ނުފެނުނު. ދެން ތިޔަ ކުރޭ.',
    noAwardYet: 'އަދި ކޯންޓްރެކްޓެއް ނުދޭ.',
    // Award / status section
    awardStatusHeading: 'ކޯންޓްރެކްޓުގެ ހާލަތު',
    sentToFinance: 'ފައިނޭންސަށް ފޮނުވި',
    goodsReceived: 'ތަކެތި ލިބުނު',
    invoiceConfirmed: 'އިންވޮއިސް ޔަގީންކުރި',
    notYet: 'އަދި ނުވޭ',
    confirmedBankAccount: 'ޔަގީންކުރި އެކައުންޓް',
    // Invoice section
    invoiceHeading: 'އިންވޮއިސް',
    viewConfirmedInvoice: 'އިންވޮއިސް ބަލާ',
    invoiceNotConfirmed: 'އިންވޮއިސް އަދި ޔަގީންކޮށްފައި ނުވޭ.',
    // Payment section
    paymentHeading: 'ފައިސާ ދެއްކުން',
    paidAt: 'ދެއްކި ތާރީޚު',
    viewSlip: 'ޓްރާންސްފަރ ސްލިޕް ބަލާ',
    notYetPaid: 'އަދި ފައިސާ ދައްކާފައި ނުވޭ.',
  },
  confirmDialog: {
    defaultTitle: 'ޔަގީންކުރައްވާ',
    confirm: 'ޔަގީންކުރޭ',
    cancel: 'ކެންސަލް',
  },
} as const;
